import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect, useDispatch, useSelector } from 'react-redux';
import { replace, split, map, has, toLower, filter, get, isEmpty } from 'lodash';
import { shouldUse } from 'utils/valuesByKey';
import TAppraisals from './tiles/TAppraisals';
import TProfile from './tiles/TProfile';
import TBirthdays from './tiles/TBirthdays';
import TEvents from './tiles/TEvents';
import TLinks from './tiles/TLinks';
import THoliday from './tiles/THoliday';
import TEvaluations from './tiles/TEvaluations';
import TGrants from './tiles/TGrants';
import TBenefits from './tiles/TBenefits';
import TAgreements from './tiles/TAgreements';
import TTransportationGrants from './tiles/TTransportationGrants';
import TTime from './tiles/TTime';
import KTile from '../components/KJRN/KTile';
import getAppraisalTitle from './utils/getAppraisalTitle';
import TEmployeeMasterCourseRequest from './tiles/TEmployeeMasterCourseRequest';
import THolidayRequest from './tiles/THolidayRequest';
import TPayslips from './tiles/TPayslips';
import TFiles from './tiles/TFiles';
import TTimeEntries from './tiles/TTimeEntries';
import TPerDiem from './tiles/TPerDiem';
import { fetchEvaluations } from '../actions/CourseEvaluation';
import { fetchAppraisal } from '../actions/Appraisal';
import { fetchCoursesIfNeeded } from '../actions/courses';
import Loading from '../components/Loading';

const styles = {
  tiles: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'center',
    flexWrap: 'wrap',
    maxWidth: 1344,
    margin: 'auto',
    marginBottom: 36,
  },
};

const tileConfig = {
  profile: {
    title: 'dash.title.profile',
    component: () => <TProfile />,
  },
  holiday: {
    title: 'dash.title.holiday',
    component: () => <THoliday />,
  },
  events: {
    title: 'dash.title.courses',
    component: () => <TEvents />,
  },
  evaluations: {
    title: 'dash.title.evaluations',
    component: () => <TEvaluations />,
  },
  appraisals: {
    title: 'dash.title.appraisals',
    component: () => <TAppraisals />,
  },
  birthdays: {
    title: 'dash.title.birthdays',
    component: () => <TBirthdays />,
  },
  links: {
    title: 'dash.title.links',
    component: () => <TLinks />,
  },
  grants: {
    title: 'dash.title.grants',
    component: () => <TGrants />,
  },
  benefits: {
    title: 'dash.title.benefits',
    component: () => <TBenefits />,
  },
  transportations: {
    title: 'dash.title.transportations',
    component: () => <TTransportationGrants />,
  },
  agreements: {
    title: 'dash.title.agreements',
    component: () => <TAgreements />,
  },
  time: {
    title: 'dash.title.punchClock',
    component: () => <TTime />,
  },
  timeentries: {
    title: 'dash.title.timeEntries',
    component: () => <TTimeEntries />,
  },
  courseapprovalrequest: {
    title: 'dash.title.courseApprovalRequest',
    component: () => <TEmployeeMasterCourseRequest />,
  },
  holidayapprovalrequest: {
    title: 'dash.title.holidayApprovalRequest',
    component: () => <THolidayRequest />,
  },
  payslips: {
    title: 'dash.title.payslips',
    component: () => <TPayslips />,
  },
  files: {
    title: 'dash.title.files',
    component: () => <TFiles />,
  },
  perdiem: {
    title: 'dash.title.perDiem',
    component: () => <TPerDiem />,
  },
};

const defaultTiles = Object.keys(tileConfig);

const Dashboard = ({ valuesByKey, links }) => {
  const dispatch = useDispatch();
  const {
    CourseEvaluationReducer: { evaluations, evaluationsLoaded },
    Appraisal: { openAppraisals, loading: appraisalLoading },
    coursesReducer: { allCourses, coursesLoaded },
  } = useSelector(state => state);
  const [filtered, setFiltered] = useState([]);

  useEffect(() => {
    dispatch(fetchEvaluations());
    dispatch(fetchAppraisal());
    dispatch(fetchCoursesIfNeeded());
  }, [dispatch]);

  tileConfig.appraisals.title = getAppraisalTitle(valuesByKey);
  const timeTitle = get(valuesByKey, ['TimeRegistration.Title', 'Value']);
  if (timeTitle === 'Absence') {
    tileConfig.timeentries.title = 'dash.title.timeEntries.Absence';
  }
  if (shouldUse(valuesByKey, 'Events')) {
    tileConfig.events.title = 'dash.title.events';
  }
  if (isEmpty(links)) {
    tileConfig.links.hide = true;
  }

  const visibleTiles = get(valuesByKey.Dashboard, 'Value');
  const tiles = visibleTiles
    ? split(replace(toLower(visibleTiles), /\s/, ''), ',')
    : defaultTiles;

  useEffect(() => {
    if (evaluationsLoaded && coursesLoaded && !appraisalLoading) {
      // APPAIL-9694 => hide events, evaluations and appraisals if no data
      setFiltered(filter(tiles, (t) => {
        const shouldShowTile = has(tileConfig, t) && !tileConfig[t].hide;
        if (t === 'events') {
          return allCourses.length && shouldShowTile;
        } else if (t === 'evaluations') {
          return evaluations.length && shouldShowTile;
        } else if (t === 'appraisals') {
          return openAppraisals.length && shouldShowTile;
        } else if (shouldShowTile) {
          return true;
        }
        return false;
      }));
    }
  }, [evaluationsLoaded, appraisalLoading, coursesLoaded]);

  if (!evaluationsLoaded || !coursesLoaded || appraisalLoading) {
    return <Loading />;
  }
  return (
    <div>
      <div style={styles.tiles}>
        {map(filtered, t => (
          <KTile key={t} cy={t} title={tileConfig[t].title}>{tileConfig[t].component()}</KTile>
        ))}
      </div>
    </div>
  );
};

Dashboard.propTypes = {
  valuesByKey: PropTypes.object,
  links: PropTypes.array,
};

export default connect(state => ({ ...state.WebValuesReducer }))(Dashboard);



// WEBPACK FOOTER //
// ./src/containers/Dashboard.js